<script>
import {config} from "@/config";

export default {
  name: "ExportItem",
  props: ['item'],
  data() {
    return {
      isDeleting: false
    }
  },
  methods: {
    deleteItem: function () {
      this.$bvModal.msgBoxConfirm( 'Вы действительно хотите удалить файл?', this.modalConfirmOptions).then(async value => {
        if (value) {
          let params = {
            id: this.item.id,
            th: this
          };
          this.isDeleting = true;
          await this.$store.dispatch('goods/category/DELETE_EXPORT', params);
          this.isDeleting = false;
        }
      })
          .catch(err => {
            console.log(err)
          })
    },
    downloadLink(id) {
      return `${config.apiUrl}/product-category-export/download/${id}/${this.getAuthToken}`
    }
  },
  computed: {
    getAuthToken: function () {
      return localStorage.authToken
    }
  }
}
</script>

<template>
  <b-row class="my-3">
    <b-col>
      <div :class="[item.state ? 'bg-success' : 'bg-primary']" class="text-white p-2">
        {{item.file_name}} ({{item.createdAt}})
      </div>
    </b-col>
    <b-col cols="1">
      <b-link
          class="btn btn-success w-100"
          variant="success"
          :href="downloadLink(item.id)"
          v-if="item.state"
          title="Скачать экспорт"
      >
        <i class="fa fa-download" aria-hidden="true"></i>
      </b-link>
    </b-col>
    <b-col cols="1">
      <b-btn
          variant="danger"
          :disabled="isDeleting"
          @click="deleteItem"
          title="Удалить экспорт"
      >
        <i class="fa fa-trash-o" aria-hidden="true"></i>
      </b-btn>
    </b-col>
  </b-row>
</template>

<style scoped>

</style>